import { Product } from 'types/productType';
import { httpGet } from 'utils';

interface Params {
  portfolioId?: number;
}

interface CurrentHoldingVT2Response {
  /** Every holding line, grouped by lwin18. The endpoint is not paginated. */
  data: Product[];
  /** Number of holding lines in `data`. Not a count of cases or bottles. */
  size?: number;
}

interface GetDetailsParams {
  lwin18: string;
}

export const fetchCurrentHoldingVT2 = (config?: Params) =>
  httpGet<CurrentHoldingVT2Response, Params>('portal/CurrentHoldings', config);

export const fetchCurrentHoldingDetailsVT2 = (params: GetDetailsParams) =>
  httpGet<Product, GetDetailsParams>('portal/CurrentHoldingsDetail', params);
